import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];
const VIEW = { once: true, amount: 0.15 };

export const Reveal = ({ as = "div", delay = 0, y = 28, className = "", children, ...rest }) => {
  const M = motion[as];
  return (
    <M
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={VIEW}
      transition={{ duration: 0.9, ease: EASE, delay }}
      className={className}
      {...rest}
    >
      {children}
    </M>
  );
};

export const LineReveal = ({ as = "h2", lines, className = "", lineClassNames = [], delay = 0, stagger = 0.09, play, testId }) => {
  const M = motion[as];
  const trigger = play === undefined ? { whileInView: "show", viewport: VIEW } : { animate: play ? "show" : "hide" };
  return (
    <M
      initial="hide"
      {...trigger}
      variants={{ hide: {}, show: { transition: { staggerChildren: stagger, delayChildren: delay } } }}
      className={className}
      data-testid={testId}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block ${lineClassNames[i] || ""}`}
            variants={{ hide: { y: "112%" }, show: { y: "0%", transition: { duration: 1.1, ease: EASE } } }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </M>
  );
};

export const Stagger = ({ className = "", children, gap = 0.07 }) => (
  <motion.div
    className={className}
    initial="hide"
    whileInView="show"
    viewport={VIEW}
    variants={{ hide: {}, show: { transition: { staggerChildren: gap } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ className = "", children, as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      variants={{ hide: { opacity: 0, y: 22 }, show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } } }}
      {...rest}
    >
      {children}
    </M>
  );
};
